module.exports = __webpack_public_path__ + "img/empty_list_info.3c73fed0.png";